export default "__VITE_ASSET__BpQt9TNP__"